import React, { useState } from "react";
import {PopupBookingComponent} from '../../../../components'
function BookingList() {
    const data = true;
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => setIsModalVisible(true);
    return (
        <div className="BoxStyle">
            <div className="container">
                <div className="title">Đặt phòng của tôi</div>
                <div className="BoxContent">
                    {data ? (<div className="ListContent">
                        <div className="itemBox">
                            <div className="hotels">Khách sạn mandala Bắc giang</div>
                            <div className="time"> <span>17-08-2021</span> - <span>30-07-2021</span></div>
                            <div className="voucher">Voucher1</div>
                        </div>
                        <div className="itemBox">
                            <div className="hotels">Khách sạn mandala Bắc giang</div>
                            <div className="time"> <span>17-08-2021</span> - <span>30-07-2021</span></div>
                            <div className="voucher">Voucher1</div>
                        </div>
                        <div className="btnAdd"><button onClick={showModal} className="btnStyle">Đặt thêm phòng</button></div>
                    </div>) :
                        (
                            <div className="dataEmpty">
                                <img className="img-fluid" src="/images/ic_event_create.png" alt="" />
                                <h5>Bạn chưa có đặt phòng</h5>
                                <button className="btnStyle" onClick={showModal}>Đặt phòng ngay</button>
                            </div>
                        )
                    }
                </div>
            </div>
            <PopupBookingComponent isModalVisible={isModalVisible} setIsModalVisible={setIsModalVisible} />
        </div>
    );
}
export default BookingList;